import { NgModule } from '@angular/core';
import { MatIconModule, MatButtonModule, MatTooltipModule } from '@angular/material';

import { CancelConfirmButtonsComponent } from './cancel-confirm-buttons.component';

@NgModule({

    imports: [
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    declarations: [
        CancelConfirmButtonsComponent
    ],
    exports: [
        CancelConfirmButtonsComponent
    ]
})
export class CancelConfirmButtonsModule {
}
